class LeadsController implements ng.IComponentController {

    constructor() {
        'ngInject';
        // console.log('LeadsController');
    }
}

export const leadsComponent : ng.IComponentOptions = {
    controller : LeadsController,
    template : require('./leads.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/crm/leads/leads.component.ts